// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6894":"6e9c69ee","9975":"6e9c69ee"}[chunkId] + ".chunk.css";
};